import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MediNearby = () => {
  const navigate = useNavigate();
  const [allMedi, setAllMedi] = useState([]);
  const [nearbyMedi, setNearbyMedi] = useState({});
  const [locationFetched, setLocationFetched] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);

  const fallbackMedi = [
    { _id: '1', title: 'Paracetamol 500mg', brief: 'Wellness Pharmacy - Marine Drive', latitude: 19.0759, longitude: 72.8772, image: '1' },
    { _id: '2', title: 'Amoxicillin 250mg', brief: 'Heritage Chemist - Gateway of India', latitude: 18.9218, longitude: 72.8347, image: '2' },
    { _id: '3', title: 'Ibuprofen 400mg', brief: 'Sunset Medico - Juhu Beach', latitude: 19.0988, longitude: 72.8260, image: '3' },
    { _id: '4', title: 'Cetirizine 10mg', brief: 'Smart Meds - Andheri East', latitude: 19.1197, longitude: 72.8468, image: '4' },
    { _id: '5', title: 'Azithromycin 500mg', brief: 'Lux Health Pharmacy - Bandra West', latitude: 19.0550, longitude: 72.8296, image: '5' },
    { _id: '6', title: 'Metformin 1000mg', brief: 'Lakeside Chemist - Powai', latitude: 19.1237, longitude: 72.9168, image: '6' },
    { _id: '7', title: 'Amlodipine 5mg', brief: 'Nature Cure Pharmacy - Thane', latitude: 19.2183, longitude: 72.9781, image: '7' },
    { _id: '8', title: 'Omeprazole 20mg', brief: 'Historic Health Mart - Vasai', latitude: 19.3919, longitude: 72.8397, image: '8' },
    { _id: '9', title: 'Montelukast 10mg', brief: 'Serenity Med Store - Navi Mumbai', latitude: 19.0330, longitude: 73.0297, image: '9' },
    { _id: '10', title: 'Losartan 50mg', brief: 'Hilltop Pharmacy - Lonavala', latitude: 18.7500, longitude: 73.4070, image: '10' }
  ];
  

  useEffect(() => {
    const fetchMedi = async () => {
      try {
        const res = await axios.get("/api/medi");
        if (res.data?.length > 0) {
          setAllMedi(res.data);
        } else {
          setAllMedi(fallbackMedi);
        }
      } catch {
        setAllMedi(fallbackMedi);
      }
    };
    fetchMedi();
  }, []);

  const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const handleNearbyMedi = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported by your browser");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLat = position.coords.latitude;
        const userLon = position.coords.longitude;

        const ranges = {
          'Within 2 Km': [],
          'Within 5 Km': [],
          'Within 10 Km': [],
          'Within 25 Km': [],
          'More than 25 Km': []
        };

        allMedi.forEach(medi => {
          if (medi.latitude && medi.longitude) {
            const distance = getDistanceInKm(userLat, userLon, medi.latitude, medi.longitude);
            if (distance <= 2) ranges['Within 2 Km'].push({ ...medi, distance });
            else if (distance <= 5) ranges['Within 5 Km'].push({ ...medi, distance });
            else if (distance <= 10) ranges['Within 10 Km'].push({ ...medi, distance });
            else if (distance <= 25) ranges['Within 25 Km'].push({ ...medi, distance });
            else ranges['More than 25 Km'].push({ ...medi, distance });
          }
        });

        setNearbyMedi(ranges);
        setLocationFetched(true);
        setLoadingLocation(false);
      },
      () => {
        alert("Location access denied or failed");
        setLoadingLocation(false);
      }
    );
  };

  return (
    <div className="p-2 bg-black border-blue-400 min-h-screen">
      <h2 className="text-lg lg:text-xl font-bold mb-2 text-white border-b-2 border-amber-500 pb-2">
        Medicine Nearby Me
      </h2>

      <div className="mb-2">
        <button
          onClick={handleNearbyMedi}
          className="px-5 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition duration-200"
        >
          {loadingLocation ? 'Fetching Location...' : 'Refresh Medicine Nearby'}
        </button>
      </div>

      {locationFetched && Object.keys(nearbyMedi).map(range => (
        nearbyMedi[range].length > 0 && (
          <div key={range} className="mb-10">
            <h3 className="text-lg lg:text-xl font-semibold mb-4 text-white">{range}</h3>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
              {nearbyMedi[range].map(medi => (
                <div key={medi._id} className="bg-black border border-blue-400 shadow-lg p-4 rounded-md">
                  <img
                    src={`/api/downloads/thinktravel/medi/${medi.image || '1'}.png`}
                    alt={medi.title}
                    className="w-full h-40 object-cover rounded"
                  />
                  <h4 className="mt-3 text-lg font-bold text-white">{medi.title}</h4>
                  <p className="text-sm text-white">{medi.brief}</p>
                  <p className="mt-1 text-sm text-white font-medium">
                    ~{medi.distance.toFixed(1)} km away
                  </p>
                  <button
                    onClick={() => navigate(`/medi/${medi._id}`)}
                    className="mt-3 px-4 py-2 bg-amber-600 text-white text-sm rounded-md hover:bg-amber-700 transition duration-200"
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default MediNearby;
